import { Component, OnInit } from '@angular/core';
import { ProjectService } from '@app/services/project.service';

import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-manage-projects',
  templateUrl: './admin-manage-projects.component.html',
})
export class ManageProjectsComponent implements OnInit {
  
  projectList: any[] = [];
  customers: any[] = [];
    error = '';
  loading = true;


  filterDtls = {
    status: '',
    customerCode: ''
  };

 
constructor(private projectService: ProjectService,  private toastr: ToastrService, private router: Router){}
  ngOnInit(): void {
    this.getCustomers();
    this.loadProjects();
  }
  getCustomers() {
      //  debugger;
    this.projectService.getCustomers().subscribe({
      next: (res: any) => {
        console.log(res);
        this.customers = res;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching Customers:', err);
        console.log(this.error);
        this.error = 'Failed to load Customers.';
        this.toastr.error('Failed to load Customers');
        this.loading = false;
      }
    });
  }


  
  newProject = {
    ProjectShortCode: '',
    ProjectName: '',  
    CustomerShortCode: '', 
    ProjectStatus: ''
  };


    addProject() {
    this.projectService.addProject(this.newProject).subscribe({
      next: () => {
        this.toastr.success('Project added successfully');
        this.newProject = {
         ProjectShortCode: '',
    ProjectName: '',  
    CustomerShortCode: '', 
    ProjectStatus: 'A'

        };
        this.loadProjects(); // reload table
      },
      error: (err) => {
        console.error('Add project failed', err);
        this.toastr.error('Failed to add project');
      }
    });
  }

  loadProjects() {
    const filters = [];

    if (this.filterDtls.status)
      filters.push({ fieldname: 'ProjectStatus', filtercriteria: 'equals', value: this.filterDtls.status });


    if (this.filterDtls.customerCode)
      filters.push({ fieldname: 'CustomerShortCode', filtercriteria: 'equals', value: this.filterDtls.customerCode });
     let body: any = { filters};

    this.projectService.getProjects(filters).subscribe({
      next: (res: any) => {
        console.log(res);
        this.projectList = res;
        this.loading = false;
      },
      error: () => {
        console.log('Error fetching projects:');
        console.log(this.error);
        this.error = 'Failed to load projects.';
        this.toastr.error('Failed to load projects');
        this.loading = false;
      }
    });

  }

  Edit_Params(project: any){
        console.log("entered update project param");
       let shortcode = project.ProjectShortCode;
    this.router.navigate(['/admin/project-parameters',shortcode ]);
    }

  goToProjectFromLesson(): void {
    this.router.navigate(['/admin/project-from-lesson']);
  }

  updateProjectStatus(project: any) {
     let body: any = { ProjectShortCode: project.ProjectShortCode, ProjectStatus: project.ProjectStatus };
      console.log("entered update project status");
      console.log(body);

     this.projectService.updateProjectStatus(body).subscribe({
      next: (res: any) => {
        console.log(res);
      },
      error: () => {
        console.log('Error updating the status:');
        console.log(this.error);
        this.error = 'Error updating the status.';
        this.toastr.error('Error updating the status');
        this.loading = false;
      }
    });

  }




  updateProjectCustomer(project: any) {
     let body: any = { ProjectShortCode: project.ProjectShortCode, CustomerShortCode: project.CustomerShortCode };
    this.projectService.updateProjectCustomer(body).subscribe({
      next: (res: any) => {
        console.log(res);
      },
      error: () => {
        console.log('Error updating the customer:');
        console.log(this.error);
        this.error = 'Error updating the customer.';
        this.toastr.error('Error updating the customer');
        this.loading = false;
      }
    });
  }
    
  }

  
  